import gql from 'graphql-tag'

const GC_GET_LOCATION_LIST = gql`
query GetLocationList {
    location(order_by: {order: asc}) {
      id
      name
      title
      description
      slug
      order
      scenarioLocations {
        scenario_id
      }
    }
  }
`

const GC_GET_LOCATION_BY_SLUG = gql`
query GetLocationBySLugList($slug: String!) {
		location(where: {slug: {_eq: $	slug}}) {
			id
			name
      title
			description
			slug
      order
			scenarios: scenarioLocations {
				scenario_id
			}
		}
  }
`

export {
    GC_GET_LOCATION_LIST,
    GC_GET_LOCATION_BY_SLUG
}